import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

import { Container } from "./SignIn.styles";

import { Button, CircularProgress, Link, TextField } from "@mui/material";
import logoImg from "../../assets/logo.png";
import { useToastr } from "../../components/toast/Toast";
import { useAuth } from "../../hooks/auth";
import { IFormErrors } from "../../interfaces/IFormErrors";
import getValidationError from "../../utils/getValidationError";

const SignIn: React.FC = () => {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const toastr = useToastr();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErros] = useState<IFormErrors>({});

  const handleSubmit = useCallback(async (): Promise<void> => {
    setLoading(true);
    setFormErros({});

    try {
      const data = {
        username,
        password,
      };

      const schema = Yup.object().shape({
        username: Yup.string().required("Usuário obrigatório"),
        password: Yup.string().required("Senha obrigatória"),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await signIn({
        username,
        password,
      })
        .then(authData => {
          if (authData.user.typeId === 2) {
            navigate("/exhibitions");
          } else {
            navigate("/home");
          }
        })
        .catch(error => {
          toastr.error(
            error.response?.data?.message || "Ocorreu um erro ao fazer login.",
          );
          setLoading(false);
          return;
        });
    } catch (err: Yup.ValidationError | any) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationError(err);
        setFormErros(errors);
        return;
      }

      toastr.error("Ocorreu um erro ao fazer login, cheque as credênciais.");
    } finally {
      setLoading(false);
    }
  }, [username, password, signIn, navigate, toastr]);

  const inputEmail = document.getElementById("username");
  const inputPassword = document.getElementById("password");
  const buttonSubmit = document.getElementById("submit");

  useEffect(() => {
    inputEmail &&
      inputPassword &&
      inputEmail.addEventListener("keydown", function (event) {
        if (event.key === "Tab" || event.key === "Enter") {
          event.preventDefault();
          inputPassword.focus();
        }
      });

    inputPassword &&
      buttonSubmit &&
      inputPassword.addEventListener("keydown", function (event) {
        if (event.key === "Tab" || event.key === "Enter") {
          event.preventDefault();
          buttonSubmit.focus();
        }
      });
  }, [inputEmail, inputPassword, buttonSubmit]);

  return (
    <Container>
      <img src={logoImg} alt="" />
      <h1>
        Sistema de julgamento de plantas <br />
        Associação da Cattleya walkeriana
      </h1>

      <form>
        <TextField
          value={username}
          onChange={e => setUsername(e.target.value.toLowerCase().trim())}
          autoComplete="off"
          helperText={formErrors.username}
          error={!!formErrors.username}
          autoFocus
          id="username"
          label="Usuário"
        />

        <TextField
          value={password}
          onChange={e => setPassword(e.target.value.trim())}
          type="password"
          autoComplete="off"
          helperText={formErrors.password}
          error={!!formErrors.password}
          id="password"
          label="Senha"
        />

        <Button
          onClick={handleSubmit}
          disabled={loading}
          variant="contained"
          id="submit"
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            <span>Entrar</span>
          )}
        </Button>

        <span>
          É um colecionador? Acesse a{" "}
          <Link
            onClick={() => {
              navigate("/collector");
            }}
          >
            Área do Colecionador
          </Link>
        </span>

        <span>
          Caso ainda não tenha uma conta,{" "}
          <Link
            onClick={() => {
              navigate("/sign-up");
            }}
          >
            Cadastre-se
          </Link>
        </span>
      </form>
    </Container>
  );
};

export { SignIn };
